var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPaypal2 = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: 0,
  y: 0,
  viewBox: "0 0 469.4 117.3",
  xmlSpace: "preserve",
  enableBackground: "new 0 0 469.4 117.3",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1,.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#777}.st1,.st3{fill:#444}.st3{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "pp_h_rgb"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M363.2 51.1c-1.4 9.1-8.4 9.1-15.1 9.1h-3.8l2.7-17.1c.2-1 1.1-1.8 2.1-1.8h1.8c4.6 0 8.9 0 11.2 2.6 1.2 1.7 1.7 4 1.1 7.2zm-2.9-23.8h-25.5c-1.7 0-3.2 1.3-3.5 3L321 95.6c-.2 1.3.8 2.5 2.1 2.5h13.1c1.2 0 2.3-.9 2.4-2.1l2.9-18.5c.3-1.7 1.8-3 3.5-3h8.1c16.8 0 26.5-8.1 29-24.2 1.1-7 0-12.6-3.3-16.4-3.5-4.4-10-6.6-18.5-6.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-2",
  className: "st1",
  d: "M181.5 51.1c-1.4 9.1-8.4 9.1-15.1 9.1h-3.8l2.7-17.1c.2-1 1.1-1.8 2.1-1.8h1.8c4.6 0 8.9 0 11.2 2.6 1.2 1.7 1.6 4 1.1 7.2zm-2.9-23.8h-25.5c-1.7 0-3.2 1.3-3.5 3l-10.3 65.3c-.2 1.3.8 2.5 2.1 2.5h12.2c1.7 0 3.2-1.3 3.5-3l2.8-17.6c.3-1.7 1.8-3 3.5-3h8.1c16.8 0 26.5-8.1 29-24.2 1.1-7 0-12.6-3.3-16.4-3.7-4.4-10.1-6.6-18.6-6.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  className: "st1",
  d: "M237.7 74.6c-1.2 7-6.7 11.7-13.8 11.7-3.5 0-6.4-1.1-8.2-3.3-1.8-2.1-2.5-5.2-1.9-8.6 1.1-6.9 6.7-11.7 13.7-11.7 3.5 0 6.3 1.1 8.1 3.3 1.9 2.2 2.7 5.2 2.1 8.6zm17-23.8h-12.2c-1 0-1.9.8-2.1 1.8l-.5 3.4-.9-1.2c-2.6-3.8-8.5-5.1-14.4-5.1-13.5 0-25 10.2-27.2 24.5-1.2 7.1.5 14 4.5 18.7 3.7 4.4 9 6.2 15.4 6.2 10.9 0 16.9-7 16.9-7l-.5 3.4c-.2 1.3.8 2.5 2.1 2.5h11c1.7 0 3.2-1.3 3.5-3l6.6-41.8c.1-1.2-.9-2.4-2.2-2.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-4",
  className: "st0",
  d: "M419.5 74.6c-1.2 7-6.7 11.7-13.8 11.7-3.5 0-6.4-1.1-8.2-3.3-1.8-2.1-2.5-5.2-1.9-8.6 1.1-6.9 6.7-11.7 13.7-11.7 3.5 0 6.3 1.1 8.1 3.3 1.9 2.2 2.6 5.2 2.1 8.6zm17-23.8h-12.2c-1 0-1.9.8-2.1 1.8l-.5 3.4-.9-1.2c-2.6-3.8-8.5-5.1-14.4-5.1-13.5 0-25 10.2-27.2 24.5-1.2 7.1.5 14 4.5 18.7 3.7 4.4 9 6.2 15.4 6.2 10.9 0 16.9-7 16.9-7l-.5 3.4c-.2 1.3.8 2.5 2.1 2.5h11c1.7 0 3.2-1.3 3.5-3l6.6-41.8c.1-1.2-.9-2.4-2.2-2.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 262.9,
  y: 50.8,
  width: 59,
  height: 63.7
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 262.9,
  y: 50.8,
  width: 59,
  height: 63.7,
  id: "mask-2_8_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path-1_8_",
  className: "st3",
  d: "M3.5 114.6h463.3V2.1H3.5v112.5z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-5",
  d: "M319.7 50.8h-12.3c-1.2 0-2.3.6-2.9 1.6l-16.9 24.9-7.2-23.9c-.4-1.5-1.8-2.5-3.4-2.5h-12c-1.5 0-2.5 1.4-2 2.8l13.5 39.6-12.7 17.9c-1 1.4 0 3.4 1.7 3.4h12.3c1.2 0 2.2-.6 2.9-1.5l40.8-58.9c.9-1.4-.1-3.4-1.8-3.4",
  mask: "url(#mask-2_8_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#444"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 440.4,
  y: 27.3,
  width: 26.5,
  height: 70.8
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 440.4,
  y: 27.3,
  width: 26.5,
  height: 70.8,
  id: "mask-2_7_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter_1_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path-1_7_",
  className: "st3",
  d: "M3.5 114.6h463.3V2.1H3.5v112.5z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-7",
  d: "M450.8 29.1l-10.5 66.5c-.2 1.3.8 2.5 2.1 2.5H453c1.7 0 3.2-1.3 3.5-3l10.3-65.3c.2-1.3-.8-2.5-2.1-2.5h-11.8c-1 0-1.9.7-2.1 1.8",
  mask: "url(#mask-2_7_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#777"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_2_",
  filterUnits: "userSpaceOnUse",
  x: 3.5,
  y: 2.2,
  width: 95.1,
  height: 112.3
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 3.5,
  y: 2.2,
  width: 95.1,
  height: 112.3,
  id: "mask-2_6_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter_2_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path-1_6_",
  className: "st3",
  d: "M3.5 114.6h463.3V2.1H3.5v112.5z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-8",
  d: "M51.7 109.9l3.4-21.7.2-1.2c.2-1 .7-2 1.5-2.7.8-.7 1.8-1.1 2.9-1.1h2.7c4.5 0 8.7-.5 12.4-1.4 3.9-1 7.4-2.6 10.4-4.7 3.1-2.2 5.8-5.1 7.8-8.6 2.2-3.6 3.8-8 4.7-13.1.9-4.4 1-8.4.5-11.8-.6-3.6-2-6.6-4.1-9.1-1.3-1.5-3-2.8-5-3.8v-.1c.7-4.4.7-8.1-.1-11.3-.7-3.2-2.3-6-4.6-8.7C79.5 5 70.5 2.2 57.8 2.2H23c-1.2 0-2.3.4-3.2 1.2s-1.5 1.8-1.7 3L3.6 98.6c-.1.8.1 1.7.7 2.3.6.6 1.4 1 2.2 1h21.7v.1l-1.5 9.4c-.1.7.1 1.5.6 2 .5.6 1.2.9 1.9.9h18.2c1 0 2-.4 2.8-1s1.3-1.6 1.4-2.6l.1-.8",
  mask: "url(#mask-2_6_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#27346a"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_3_",
  filterUnits: "userSpaceOnUse",
  x: 3.4,
  y: 2.1,
  width: 86.4,
  height: 100
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 3.4,
  y: 2.1,
  width: 86.4,
  height: 100,
  id: "mask-2_5_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter_3_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path-1_5_",
  className: "st3",
  d: "M3.5 114.6h463.3V2.1H3.5v112.5z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-9",
  d: "M39.2 30.8c.2-1.5 1.2-2.7 2.4-3.3.6-.3 1.2-.4 1.9-.4H71c3.2 0 6.3.2 9 .7.8.1 1.6.3 2.3.4.7.2 1.5.4 2.2.6.4.1.7.2 1 .3 1.4.5 2.6 1 3.8 1.6 1.4-8.7 0-14.7-4.7-20.1C79.4 4.7 70 2.1 57.9 2.1H23c-2.5 0-4.6 1.8-4.9 4.2L3.5 98.6c-.3 1.8 1.1 3.5 3 3.5H28l11.2-71.3",
  mask: "url(#mask-2_5_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#444"
})), /*#__PURE__*/React.createElement("path", {
  id: "Fill-11",
  className: "st0",
  d: "M89.3 30.7c-.1.7-.2 1.3-.4 2-4.6 23.7-20.4 31.8-40.5 31.8H38.2c-2.5 0-4.5 1.8-4.9 4.2l-6.7 42.7c-.3 1.6 1 3 2.6 3h18.2c2.2 0 4-1.6 4.3-3.7l.2-.9 3.4-21.7.2-1.2c.3-2.1 2.2-3.7 4.3-3.7h2.7c17.6 0 31.4-7.2 35.4-27.9 1.7-8.6.8-15.9-3.6-20.9-1.4-1.4-3-2.7-5-3.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-12",
  d: "M84.5 28.8c-.7-.2-1.4-.4-2.2-.6-.7-.2-1.5-.3-2.3-.4-2.8-.4-5.8-.7-9-.7H43.6c-.7 0-1.3.2-1.9.4-1.3.6-2.2 1.8-2.4 3.3l-5.8 36.9-.2 1.1c.4-2.4 2.5-4.2 4.9-4.2h10.3c20.1 0 35.9-8.2 40.5-31.8.1-.7.3-1.4.4-2-1.2-.6-2.4-1.1-3.8-1.6-.4-.2-.8-.3-1.1-.4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#353535"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPaypal2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconPaypal2.a3b8d72a.svg";
export { ForwardRef as ReactComponent };